import getCollectionQuery from "../../utils/getCollectionQuery";

export default function getDistributionChannelsQuery(firebase) {
	return getCollectionQuery(firebase.firestore().collection("distributionChannels"), {
		softDeletes: true,
		orderBy: ["name", "desc"],
	});
}
